<div class="form-field" [formGroup]='parent' [ngClass]="{'done-btn-style': doneBtnFlag && selectedProductCode && selectedProductCode !== 'C',
'done-btn-style-2': doneBtnFlag && selectedProductCode && selectedProductCode === 'C',
'mar-t-0': doneBtnFlag && selectedProductCode && selectedProductCode === 'H' && router.url === '/quote/your-product-options'}">


  @if (!isloading) {
<button [id]="'btn-'+getID(controllerData['label'])" [name]="controllerData['name']" class="btn margin-0" [ngClass]="[(buttonType === 'normalCTA')?'btn-cta btn-border':'',
  (buttonType === 'chevronCTA')?'btn-cta btn-chevron btn-border':'', (buttonType === 'primarybutton')?'btn-primary btn-border':'', (buttonType === 'secondarybutton')?'btn-secondary btn-border':'',
  (buttonType === 'secondarychoosebutton')?'btn-secondary btn-border chooseBtn':'', controllerData['showIcon']?'text-left':'',
  (controllerData['name'] == 'log_in' || controllerData['name'] == 'register')?'mr-1':'']" type="button"
      [attr.aria-describedby]="controllerData['label'] === 'Start' ? (controllerData['label'] + '; button; This will take approximately 15 mins') : controllerData['label']" [disabled]="isDisabled">{{controllerData['label']}}
      @if (controllerData['showIcon']) {
        <i class="icon icon-plus fl-right" aria-hidden="true"></i>
      }
    </button>
  }
  @if (isloading) {
    <button class="btn btn-loading btn-opacity margin-0 mr-1" type="button">
      <div class="spinner spinner-white">
        <div class="spinner-ring" aria-hidden="true"></div>
        <span class="access">Loading...</span>
      </div>
    </button>
  }
</div>